import axios from "../interceptos/axios_prod";

export default class EmbedService {
  async getEmbedBySubGroup(id) {
    return await axios.get(`grupo/embed-by-sub-group/${id}`);
  }
}
